import {
  lazy,
  Suspense,
  useCallback,
  useMemo,
  useRef,
  useState,
} from "react";

const popupFormLoader = () =>
  import("@/components/features/forms/PopupForm");

const PopupForm = lazy(popupFormLoader);

export const useServiceInquiryModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [initialServices, setInitialServices] = useState<string[] | undefined>();
  const hasPrefetchedRef = useRef(false);

  const prefetch = useCallback(() => {
    if (hasPrefetchedRef.current) {
      return;
    }
    hasPrefetchedRef.current = true;
    void popupFormLoader();
  }, []);

  /** Opens the quote sheet; `services` starts those service ids ticked. */
  const open = useCallback(
    (services?: string[]) => {
      prefetch();
      setInitialServices(Array.isArray(services) ? services : undefined);
      setIsOpen(true);
    },
    [prefetch]
  );

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const modal = useMemo(() => {
    if (!isOpen) {
      return null;
    }

    return (
      <Suspense fallback={null}>
        <PopupForm isOpen={isOpen} onClose={close} initialServices={initialServices} />
      </Suspense>
    );
  }, [isOpen, close, initialServices]);

  return {
    isOpen,
    open,
    close,
    prefetch,
    modal,
  };
};


